import { all, call } from "redux-saga/effects";

import { authSagas } from "../areas/auth/state/sagas";
import { frameSagas } from "../areas/frame/state/sagas";
import { profileSagas } from "../areas/profile/state/sagas";

import { loadingSagas } from "./loading/sagas";

export function* rootSaga() {
  yield all([call(authSagas), call(profileSagas), call(loadingSagas), call(frameSagas)]);
}
